import { Injectable, NgZone } from '@angular/core';
import { FileObject, MetaData, FileInclMetaData } from '../../models';
import { OauthHelper } from '../webservice'
import { Constants } from '../constants';
import { Observable, Observer } from 'rxjs/Rx';
import { HttpClient } from './http-client.service';
import { Response } from '@angular/http';
let FileSaver = require('../../FileSaver');

@Injectable()
export class FileApi {
	private static XHR_FINISHED_STATE = 4;
	private URL = "/api/files"
	constructor(private oauthHelper: OauthHelper, private ngZone: NgZone, private httpClient: HttpClient) {

	}
	public getFileInclMetaData(metaDataId: string): Observable<FileInclMetaData> {
		return this.httpClient.get(this.URL + "/v1/" + metaDataId + "/preview")
			.map(response => <FileInclMetaData>response.json())
			.catch(this.handleError);
	}

	public getFileInclMetaDataList(metaDataIds: string[]): Observable<FileInclMetaData[]> {
		let metaDataObservables = []
		for (let id of metaDataIds) {
			metaDataObservables.push(this.getFileInclMetaData(id))
		}
		return <Observable<FileInclMetaData[]>> Observable.forkJoin(metaDataObservables);
	}

	public getMetaData(metaDataId: string): Observable<MetaData> {
		return this.httpClient.get(this.URL + "/v1/metaData/" + metaDataId)
			.map(response => <MetaData>response.json())
			.catch(this.handleError);
	}

	public updateMetaData(metaDataId: string, metaData: MetaData): Observable<MetaData> {
		let body = JSON.stringify(metaData);
		return this.httpClient.post(this.URL + "/v1/metaData/" + metaDataId, body)
			.map(response => <MetaData>response.json())
			.catch(this.handleError)
	}

	public downloadFile(fileStorageName: string, saveAsFilename: string) {
		let xhr = new XMLHttpRequest();
		xhr.open("GET", ZUUL_BACKEND + this.URL + "/v1/files/" + fileStorageName)
		xhr.responseType = 'blob';
		xhr.setRequestHeader('Authorization', "Bearer " + this.oauthHelper.getAccessToken());
		if (localStorage.getItem(Constants.SESSION_ID) != null) {
			xhr.setRequestHeader(Constants.SESSION_ID_HEADER, localStorage.getItem(Constants.SESSION_ID));
		}
		xhr.onload = (e) => {
			let blob = xhr.response;
			FileSaver.saveAs(blob, saveAsFilename, true);
		}
		xhr.send()
	}

	public uploadFile(item: FileObject) {
		return Observable.create((observer: Observer<Event>) => {
			let xhr = new XMLHttpRequest();
			let form = new FormData();
			form.append("file", item.file, item.file.name)
			form.append("metaData", JSON.stringify(item.metaData))
			xhr.open("POST", ZUUL_BACKEND + this.URL + "/v1")
			xhr.setRequestHeader('Authorization', "Bearer " + this.oauthHelper.getAccessToken());
			if (localStorage.getItem(Constants.SESSION_ID) != null) {
				xhr.setRequestHeader(Constants.SESSION_ID_HEADER, localStorage.getItem(Constants.SESSION_ID));
			}
			xhr.upload.onabort = (e) => {
				e["filename"] = item.uniqueFilename
				this.ngZone.run(() => observer.error(e));
			}
			xhr.upload.onprogress = (e) => {
				e["filename"] = item.uniqueFilename
				this.ngZone.run(() => observer.next(e));
			}
			xhr.upload.onerror = (e) => {
				//e["filename"] = item.uniqueFilename
				this.ngZone.run(() => observer.error(e));
			}
			xhr.upload.onloadstart = (e) => {
				e["filename"] = item.uniqueFilename
				this.ngZone.run(() => observer.next(e));
			}
			xhr.upload.onload = (e) => {
				e["filename"] = item.uniqueFilename
				this.ngZone.run(() => observer.next(e));
			}
			xhr.upload.onloadend = (e) => {
				e["filename"] = item.uniqueFilename
				this.ngZone.run(() => observer.next(e));
			}
			xhr.onreadystatechange = (e) => {
				if (FileApi.XHR_FINISHED_STATE == xhr.readyState) {
					if (xhr.status >= 400) {
						console.log("sending error")
						this.ngZone.run(() => {
							let error = new Error(item.uniqueFilename);
							error["filename"] = item.uniqueFilename;
							observer.error(error);
						});
					} else {
						let response = JSON.parse(xhr.responseText.trim())
						e["filename"] = item.uniqueFilename
						e["metaData"] = response
						this.ngZone.run(() => observer.next(e));
						this.ngZone.run(() => observer.complete());
					}
				}
			}

			xhr.send(form);

		})
	}

	private handleError = (error: Response) => {
		console.error(error);
		return Observable.throw(error.json());
	}

}

export class MyProgressEvent extends ProgressEvent {
	public filename: string
	public metaData: MetaData
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/file-api.service.ts